var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('img', {
    staticClass: "event-icon",
    style: {
      width: _vm.size + 'px'
    },
    attrs: {
      "src": require("@/assets/event/icon/".concat(_vm.mode, "/").concat(_vm.imageName, ".svg")),
      "alt": "Event icon"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }